const ProductOptions = (price, currentVariantPurchaseType, subscriptionStatus, requireSubscriptionConfirmation = false) => ({
  orderType: currentVariantPurchaseType, // one-off, subscription, both
  price: price,
  qty: 1, // Initialize the quantity property
  itemAmount: initialAmount,
  selectedPurchaseType: window.selectedPurchaseType ? window.selectedPurchaseType : 'subSelected',
  selectedSellingPlan: null,
  availableSellingPlans: [], // so we can pass through to cart to allow switching
  loading: false,
  error: null,
  subscriptionPercentage: initialPercentage,
  subscriptionStatus: subscriptionStatus,
  subscriptionConfirmed: false,
  backgroundColour: '',
  requireSubscriptionConfirmation: Boolean(requireSubscriptionConfirmation),
  subscriptionConfirmationError: false,
  isCartButtonActive() {
    if (this.loading) {
      return false;
    }

    if (this.requireSubscriptionConfirmation && (this.orderType == 'subscription' || this.orderType == 'both')) { // If product has subscription option
      if (this.selectedPurchaseType == 'subSelected') { // If checkbox is checked
        return this.subscriptionConfirmed
      }
    }
    return true;
  },

  init() {
    if (this.$refs.variants) {
      if (this.orderType === 'subscription') {
        this.selectedSellingPlan = this.$refs.sellingPlanPicker.value;
      }
    }

    if (document.querySelector('.form-wrapper')?.dataset.background != null) {
      this.backgroundColour = document.querySelector('.form-wrapper').dataset.background;
    }

    const sellingPlanPickerSelect = this.$root.querySelector('#sellingPlanPickerSelect');
    if (sellingPlanPickerSelect) {
      this.itemAmount = sellingPlanPickerSelect.selectedOptions[0].dataset.amount;
    }

    const sellingPlanSelect = this.$root.querySelector('.sellingPlanList');
    if (sellingPlanSelect) {
      const sellingPlanOptions = sellingPlanSelect.options;

      if (sellingPlanOptions) {
        // Need to check why it's getting pulled to the cart & CMS Order details
        this.availableSellingPlans = Array.from(sellingPlanOptions).map((option) => ({
          value: option.value,
          label: option.text,
        }));
      }
    }

    if (this.selectedPurchaseType === 'one_time') {
      setTimeout((_) => {
        this.$root
          .querySelector('input[type="radio"][value="one_time"]')
          .dispatchEvent(new Event('change', { bubbles: true }));
      }, 1);
    }

    if (this.selectedPurchaseType === 'subSelected') {
      setTimeout((_) => {
        this.$root
          .querySelector('input[type="radio"][value="subSelected"]')
          .dispatchEvent(new Event('change', { bubbles: true }));
      }, 1);
    }
  },

  minus() {
    this.qty = Math.max(1, this.qty - 1);
  },
  plus() {
    this.qty = Math.min(100, this.qty + 1);
  },
  isMin() {
    return this.qty <= 1;
  },
  isMax() {
    const maxQuantity = this.$root.querySelector('input[name="quantity"]').max;
    return this.qty >= maxQuantity;
  },
  change(e) {
    this.$refs.variantPicker.value = e.target.value;
    this.price = e.target.dataset.price;
    const selectedVariantOption = e.target.selectedOptions[0];
    this.subscriptionStatus = selectedVariantOption.dataset.substatus;
    this.updateVariantInUrl(e.target.value);

    const newImageUrl = selectedVariantOption.dataset.variantimage;

    this.updateVariantImage(newImageUrl);
  },
  changePlan(e) {
    const selectedOption = e.target.selectedOptions[0];
    this.selectedSellingPlan = selectedOption.value;
    this.subscriptionPercentage = selectedOption.dataset.percentage;
    this.itemAmount = selectedOption.dataset.amount;
  },

  updateVariantInUrl(variantId) {
    const params = new URLSearchParams(window.location.search);
    params.set('variant', variantId);
    history.replaceState({}, '', `${window.location.pathname}?${params}`);
  },

  updateVariantImage(imageUrl) {
    const parent = this.$root.closest('.product-details-wrapper');
    if (!parent) return false;

    const imageElement = parent.querySelector('.product-featured-image');
    const thumbnailElement = parent.querySelector('.variant-thumbnail');

    if (imageElement && imageUrl) {
      imageElement.src = imageUrl;
    }
    if (thumbnailElement && imageUrl) {
      thumbnailElement.src = imageUrl;
    }
  },
  subscribeClick(e) {
    e.preventDefault();

    window.selectedPurchaseType = 'subSelected';

    const selectedOption = this.$refs.sellingPlanPickerSelect.selectedOptions[0];
    this.selectedSellingPlan = selectedOption.value;
    this.itemAmount = selectedOption.dataset.amount;
    this.subscriptionPercentage = selectedOption.dataset.percentage;
  },
  oneOffClick(e) {
    e.preventDefault();

    window.selectedPurchaseType = 'one_time';

    this.selectedSellingPlan = null;
  },
  validate() {
    if (this.requireSubscriptionConfirmation && (this.orderType == 'subscription' || this.orderType == 'both')) { // If product has subscription option
      if (this.selectedPurchaseType == 'subSelected') { // If checkbox is checked
        if (this.subscriptionConfirmed) {
          return true;
        } else {
          this.subscriptionConfirmationError = true;
          return false;
        }
      }
    }

    return true;
  },
  addToCart(e) {
    e.preventDefault();

    if (!this.validate()) {
      return false;
    }

    this.loading = true;
    const lineItems = [];

    const lineItem = {
      quantity: this.qty,
      id: this.$refs.variantPicker.value,
    };

    if (this.selectedSellingPlan) {
      lineItem.selling_plan = this.selectedSellingPlan;
    }

    lineItems.push(lineItem);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: lineItems,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status && res.status !== 200) {
          throw new Error(res.description);
        }

        this.$dispatch('cart:product-added');
      })
      .catch((err) => {
        this.error = err;
      })
      .finally(() => {
        this.loading = false;
      });
  },
});

export default ProductOptions;
